<sgt-multi-select
  [settings]="settings"
  [options]="options"
  [(ngModel)]="idsFormasPagamentos"
  (ngModelChange)="onSelectionChange()"
  (search)="onSearch()"
  (isFirstOpened)="firstOpened($event)">
</sgt-multi-select>
